import dayjs from "dayjs";
import { getValuebyId } from "../../Utils/handler";

export const dynamicPersonalDetails = (fields, data) => {
    const personalDetails = {};

    fields.forEach((field) => {
        const { fieldKey, defineActionType } = field;

        // Handle different field types
        if (defineActionType === 'file') {
            personalDetails[fieldKey] = data?.personalDetails?.[fieldKey] || null;
        } else if (defineActionType === 'number') {
            personalDetails[fieldKey] = +data?.personalDetails?.[fieldKey] || "";
        } else {
            personalDetails[fieldKey] = data?.personalDetails?.[fieldKey] || "";
        }
    });

    return personalDetails;
};

export const dynamicGeneralDetails = (fields, data) => {
    const generalDetails = {};

    fields.forEach((field) => {
        const { fieldKey, defineActionType } = field;

        if (fieldKey === "dob") {
            generalDetails[fieldKey] = dayjs(data?.generalDetails?.[fieldKey], 'DD/MM/YYYY').format('YYYY/MM/DD');
        } else if (defineActionType === "number") {
            generalDetails[fieldKey] = +data?.generalDetails?.[fieldKey] || "";
        } else {
            generalDetails[fieldKey] = data?.generalDetails?.[fieldKey] || "";
        }
    });

    return generalDetails;
};
export const dynamicNomineeDetails = (fields, data, relationList) => {
    const nomineeDataArray = data?.nomineeDetails || []; // Get nominee details array from data
    const nomineeDetails = nomineeDataArray.map((nomineeData) => {
        const nomineeObject = {};

        fields.forEach((field) => {
            const { fieldKey, defineActionType } = field;

            if (fieldKey === "relation") {
                // Handle relation key with relation list lookup
                nomineeObject[fieldKey] = getValuebyId(nomineeData?.[fieldKey], relationList);
            } else if (defineActionType === "number") {
                // Handle number type fields
                nomineeObject[fieldKey] = +nomineeData?.[fieldKey] || "";
            } else {
                // Handle other fields
                nomineeObject[fieldKey] = nomineeData?.[fieldKey] || "";
            }
        });

        return nomineeObject; // Return processed object for each nominee
    });

    return nomineeDetails; // Return the array of nominee objects
};